import { IDecisionListFilterRaw } from 'DecisionListPackage/MainModule/interfaces/IDecisionListFilterRaw';

import { IDecisionListFilter } from '../interfaces/IDecisionListFilter';

export function mapDecisionFilterToRaw(data: IDecisionListFilter): IDecisionListFilterRaw {
  const { supervisionType } = data;

  return {
    name: data.name,
    years: data?.years?.map(yearSelectOption => Number(yearSelectOption.value)) || [],
    domainIds: data?.domains?.map(domain => domain?.id) || [],
    includeDomainChild: data?.includeDomainChild,
    kinds: data?.kinds?.map(kindSelectOption => kindSelectOption.label) || [],
    knoIds:
      data?.controllingOrganizations?.map(
        controllingOrganization => controllingOrganization?.idStr || controllingOrganization?.id,
      ) || [],
    includeChildKno: data?.includeChildKno,
    includeChildProsecutorOrg: data?.includeChildProsecutorOrg,
    prosecutorOrganizationErvkUuids:
      data?.prosecutorOrganizations?.map(
        prosecutorOrganizationSelectOption => prosecutorOrganizationSelectOption.ervkUuid,
      ) || [],
    ignoreKno: data?.ignoreKno,

    controlKindCode:
      supervisionType && 'code' in supervisionType
        ? supervisionType.code
        : (typeof supervisionType?.value === 'number' && supervisionType?.value) || '',
    reasonIds: data?.reasons?.map(genericReasonSelectOption => genericReasonSelectOption.id) || [],
    subjectTypeCodes:
      (data?.subjectTypes?.map(subjectTypeSelectOption => subjectTypeSelectOption.code).filter(Boolean) as string[]) ||
      [],
    subjectOrgName: data?.subjectOrgName,
    subjectOgrn: data?.subjectOgrn,
    subjectInn: data?.subjectInn,
    subjectKpp: data?.subjectKpp,
    subjectCountryIds: data?.subjectCountries?.map(countrySelectOption => countrySelectOption.id) || [],
    objectAddress: data?.objectAddress,
    objectTypeIds: data?.objectTypes?.map(objectTypeSelectOption => objectTypeSelectOption.id) || [],
    objectKindIds: data?.objectKinds?.map(objectKindSelectOption => objectKindSelectOption.value.dictVersionId) || [],
    objectSubKindIds:
      data?.objectSubKinds?.map(objectSubKindSelectOption => objectSubKindSelectOption.value.dictVersionId) || [],
    objectRiskCategoryId: data?.objectRiskCategory?.id,
    objectDangerClassId: data?.objectDangerClass?.id,
    signed: data?.signed?.value,
    statusIds: data?.statuses?.map(statusSelectOption => statusSelectOption.id) || [],
    pubStatuses: data?.pubStatuses?.map(pubStatusSelectOption => pubStatusSelectOption.value) || [],
    number: data?.number,
    deletedInclude: data?.deletedInclude?.value,
    deletedOnly: data?.deletedOnly?.value,
    isTest: data?.isTest?.value,
  };
}
